import validate from 'lib/utils/validationRules';
import axios from 'lib/utils/axios';
import logrocket from '@/services/logrocket';

import MerchantService from 'services/merchant';
import TransactionService from 'services/transaction';

import declareTransaction from 'api/requests/selfEmployed/declareTransaction';

const DECLARATION_ERROR_ALERTS = {
  ['DECLARATION_ERROR']: 'fns.is.not.responding',
  ['DECLARATION_LIMIT_EXCEEDED']: 'declaration.limited',
  ['INN_NOT_REGISTERED']: 'status.on.fns.changed',
  ['DECLARATION_UNKOWN']: 'fns.off',
};

function getErrorMessage(error) {
  const { data } = error;
  const message = validate.isObjectWithFields(DECLARATION_ERROR_ALERTS, [data?.status])
    ? DECLARATION_ERROR_ALERTS[data.status] : DECLARATION_ERROR_ALERTS.DECLARATION_UNKOWN;

  return message;
}

/**
 * Сервис для работы с функционалом декларирования транзакций
 */
const TransactionDeclarationService = {
  // Логика определения задекларированной транзакции
  checkDeclared: (transaction) => transaction.declared,

  // Логика определения доступности декларирования транзакции
  checkAllowDeclaring: (merchant, transaction) => {
    // Если состояние самозанятого активировано
    const isSelfEmployedActivated = MerchantService.checkSelfEmployed(merchant);

    // Если по транзакции не инициирован возврат или он прошел не успешно
    const isRefundInactive = !TransactionService.checkActiveStatusRefund(transaction);

    // Если траназкция проведена в криптовалюте
    const isCryptoCurrency = TransactionService.checkCryptoCurrency(transaction);

    return isSelfEmployedActivated && isRefundInactive && !isCryptoCurrency;
  },

  // Логика декларирования транзакции
  declaration: async (payload) => {
    try {
      const { data } = await declareTransaction(axios, payload);

      return validate.isNotEmptyObject(data);
    } catch (error) {
      logrocket.logger(error);
      throw new Error(getErrorMessage(error));
    }
  },
};

export default TransactionDeclarationService;
